import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CountryStatesService} from '../../country-states-service';
import {ICountry} from '../address/country';
import {MatSelectChange} from '@angular/material/select';

@Component({
    selector: 'app-country-select',
    templateUrl: './country-select.component.html',
    standalone: false
})
export class CountrySelectComponent implements OnInit {
  countries: ICountry[];

  @Input() selectedCountryId = 1;
  @Output() countryChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() openedChange: EventEmitter<any> = new EventEmitter<any>();


  constructor(
    private countryStatesService: CountryStatesService,
  ) {
  }

  ngOnInit(): void {
    this.countryStatesService.getCountries().subscribe(countries => this.countries = countries);
  }

  countryChanged(event: MatSelectChange) {
    this.countryChange.emit(event.value);
  }

  onOpenedChanged($event: boolean) {
    this.openedChange.emit($event);
  }
}
